<script setup lang="ts">
export type Item = {
  color: string
  label: string
}
type Props = {
  items: Item[]
}

const props = defineProps<Props>()
</script>

<template>
  <div
    class="d-flex flex-row flex-wrap justify-content-center"
    style="font-size: .75rem;"
  >
    <div
      v-for="(item, index) in props.items"
      :key="item.color + '_' + item.label"
      class="d-flex flex-row gap-1 align-items-center"
      :class="{'ms-3': index > 0}"
    >
      <div
        class="legend-color"
        :style="{
          backgroundColor: item.color
        }"
      ></div>
      <span>{{ item.label }}</span>
    </div>
  </div>
</template>

<style scoped>
.legend-color {
  width: 2.5rem;
  height: .75rem;
}
</style>
